import {
  Card,
  GKButton,
  GKClientDataGrid,
  Grid2,
  SendIcon,
  Show,
  Typography,
} from "components";
import { useAgreement } from "hooks/useAgreement";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ClientAgreementColumns } from "utils/columns";
import useDocumentTitle from "utils/useDocumentTitle";
import ClientCustomAgreement from "./ClientCustomAgreement";

const ClientAgreement = () => {
  useDocumentTitle("Client Agreement");

  const { id } = useParams();

  const [customAgreement, setCustomAgreement] = useState(false);

  const { getAgreement, isAgreementLoading } = useAgreement();

  return (
    <DashboardLayout title="Client Agreement">
      <Card>
        <Grid2 container>
          <Grid2 size={12} display={"flex"} alignItems={"center"}>
            <Grid2 size={8}>
              <Typography fontSize={14} fontWeight={500}>
                Client Name
              </Typography>
              <Typography
                fontSize={16}
                fontWeight={700}
                color={"var(--primary-900)"}
              >
                {getAgreement?.data?.data?.name || "-"}
              </Typography>
            </Grid2>

            <Grid2 size={8} textAlign={"right"}>
              <GKButton
                onClick={() => setCustomAgreement(true)}
                variant="outlined"
                color="dark"
                startIcon={<SendIcon />}
              >
                Request Sign
              </GKButton>
            </Grid2>
          </Grid2>
        </Grid2>
      </Card>
      <Grid2
        mt={2}
        container
        height={
          getAgreement?.data?.data?.response?.length === 0 ? "100%" : "auto"
        }
      >
        <GKClientDataGrid
          name="clientAgreement"
          showSearch={false}
          loading={isAgreementLoading}
          columns={ClientAgreementColumns()}
          rows={getAgreement?.data?.data?.response || []}
          showHeaderGrid={false}
        />

        <Show.When isTrue={customAgreement}>
          <ClientCustomAgreement
            setOpen={setCustomAgreement}
            open={customAgreement}
            type="client"
            id={id}
          />
        </Show.When>
      </Grid2>
    </DashboardLayout>
  );
};

export default ClientAgreement;
